export default __webpack_public_path__ + "static/product_004-f79107f8fa4a0ae76387230e4eeeaf72.jpg";